import React from 'react';
import Names from './Names';
import { Loading } from '../common';


const divStyle = {
    flex: 1,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "75px",
}

const NamesList = ({names,setCurrentName, addFavourites})=>{
const nameIds = Object.keys(names)
const NamesList = nameIds.map((nameId)=>{ 
    return  <Names key={nameId} name={names[nameId]}
                      setCurrentName={setCurrentName}
                       addFavourites={addFavourites}/>
                    }
                )

    return(
        <div style={divStyle}>
           <ul>
              {nameIds.length === 0 ? <Loading/> : NamesList }
            </ul>
        </div>
    )
};

export default NamesList;


// WEBPACK FOOTER //
// ./src/components/mainpage/NamesList.js